module.exports = __webpack_public_path__ + "static/media/get_help_image_mobile.b156ddd1.png";